module.exports = __webpack_public_path__ + "e07734135e3ce6ffba8f2f37795e5006.svg";